<template lang="">
  <!-- Modal -->
  <div
    class="modal fade"
    id="registerModal"
    tabindex="0"
    aria-labelledby="registerModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close float-end"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <webapp-RegistrationComponent />
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="loginModal"
    tabindex="-1"
    aria-labelledby="loginModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body" id="login-box">
          <button
            type="button"
            class="btn-close float-end"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <h3 class="text-center" style="color: #439539">Login</h3>
          <p class="text-center">
            Join today and get 100% first deposit match as a Free Bet. Visit our
            T&C's page for offer details.
          </p>
          <br />
          <form>
            <div class="mb-3">
              <input
                type="number"
                class="form-control"
                data-val="true"
                errorText="Invalid mobile number"
                pattern="^[1-9][0-9]{8}$|^0[0-9]{9}$"
                id="username"
                name="username"
                required="true"
                placeholder="Mobile Number"
              />
              <span class="error-text" />
            </div>
            <div class="mb-3">
              <input
            data-translate-set="ErrorMessages"
            data-translate-key="PasswordName"
            data-translate-type="placeholder"
            class="form-control passwordToggle valid"
            data-val="true"
            required="true"
            placeholder="Password"
            errorText="Invalid password."
            pattern="^[a-zA-Z0-9\@\#\$\%\.\!\&amp;\+\-]{5,10}"
            maxlength="10"
            id="loginPassword"
            name="loginPassword"
            type="password"
        />
              <span class="error-text" />
            </div>
          </form>
          <button class="form-btn-one d-block mx-auto" @click="validateStep1">Login</button>
          <span  v-if="showGeneralError" class="error-text" style="width: 100%;display: block;">
            {{ GeneralErrorText }}
          </span>
          <br />
          <p class="text-center">Don't have an account yet?</p>
          <button
            data-bs-toggle="modal"
            data-bs-target="#registerModal"
            data-bs-dismiss="modal"
            class="form-btn-two d-block mx-auto"
          >
            Sign up
          </button>
        </div>
      </div>
    </div>
  </div>
  <div :class="'banner-container ' + this.getContent?.content.currentPage">
    <div v-for="item in this.getContent?.content.pageContent?.PCM?.WP" :key="item?.WPName" v-show="item?.WPName === 'desktopimage'">
      <div class="banner-image d-none d-lg-block">
        <div v-bind:style="{ backgroundImage: 'url(' + item?.WPC + ')' }" alt=""></div>
      </div>
    </div>
    <div v-for="item in this.getContent?.content.pageContent?.PCM?.WP" :key="item?.WPName" v-show="item?.WPName === 'mobileimage'">
      <div class="banner-image d-block d-lg-none">
        <div v-bind:style="{ backgroundImage: 'url(' + item?.WPC + ')' }" alt=""></div>
      </div>
    </div>

    <div class="container">
        <div class="row align-items-center desk-offer">
          <div class="col-7 d-none d-lg-block">  
            <div v-for="item in this.getContent?.content.pageContent?.PCM?.WP" :key="item?.WPName" v-show="item?.WPName === 'deposittext'">   
              <div class="desk-offer-content" v-html="item.WPC"></div>
            </div>         
            <button
              data-bs-toggle="modal"
              data-bs-target="#registerModal"
              class="cta d-block"  
              :style="{backgroundColor: this.getContent?.content.currentPageColor}">
              {{ this.getContent?.content?.signUpText }}
            </button>
          </div>
        </div>
      </div>
      <div class="carousel-caption d-block d-lg-none">
        <div class="caption-inner">
          
          <p class="heading">
            <div v-for="item in this.getContent?.content.pageContent?.PCM?.WP" :key="item?.WPName" v-show="item?.WPName === 'mobiledeposittext'">
              <div v-html="item?.WPC"></div>
            </div>
          </p>
          <div class="" v-html="this.getContent?.content?.mobileOnlyDepositText"></div>
          <button
            data-bs-toggle="modal"
            data-bs-target="#registerModal"
            class="cta d-block mx-auto"
            :style="{backgroundColor: this.getContent?.content.currentPageColor}">
            {{ this.getContent?.content?.signUpText }}
          </button>
        </div>
      </div> 
    </div>

</template>

<script>
import { store } from "../store/store.js";
import RegistrationComponent from "./RegistrationComponent.vue";
import { StorageUtil } from "../utils/storageUtils";

export default {
  components: {
    "webapp-RegistrationComponent": RegistrationComponent,
  },
  data() {
    return {
      showGeneralError: false,
      GeneralErrorText: "",
    };
  },
  computed: {
    currentRouteName() {
      return this.$router.currentRoute.value.params.pageName;
    },
    getCurrentPage() {
      return {
        store: store,
      };
    },
    getContent() {
      return {
        content: {
          pageContent: store?.pageContent,
          currentPage: store?.currentPage?.toLowerCase().trim(),
          currentPageColor: store?.currentPageColor,

          // Header content
          signUpText: store?.content?.signUpText,
          loginText: store?.content?.loginText,
          logoImageUrl: store?.content?.logoImage,
          depositText: store?.content?.depositText,
          mobileOnlyDepositText: store?.content?.mobileOnlyDepositText,

          //carousel-indicator
          sportsText: store?.content?.sportsText,
          jackpotsText: store?.content?.jackpotsText,
          horseRacingText: store?.content?.horseRacingText,
          virtualsText: store?.content?.virtualsText,
          esportsText: store?.content?.esportsText,
          // // Desktop Banners
        },
      };
    },
  },
  methods: {
    validateStep1() {
      const inputs = document.querySelectorAll("#login-box input");
      let valid = true;
      inputs.forEach((input) => {
        const result = this.validate(null, input);
        if (!result) {
          valid = false;
        }
      });
      if (valid) {
        document.getElementById("loading").style.display = "block"
        var url = "https://www-betway-co-za-betwayreg.datafree.io/appsynapse/auth/users/authenticate?nogeoredirect=1";
            fetch(url, {
              method: "POST",
              body: JSON.stringify({
                username:document.getElementById("username").value,
                password:document.getElementById("loginPassword").value,
                countryCode:"ZA"
            }),
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            })
              .then((response) => response.text())
              .then((data) => {
                console.log(JSON.parse(data));
                data = JSON.parse(data);
                if (data.errorCode) {
                  this.GeneralErrorText = data.errorMessage;
                  this.showGeneralError = true;
                  document.getElementById("loading").style.display = "none";
                } else {
                  const storage = new StorageUtil();
                  storage.setWildCardCookie("betway-auth", data.access_token, 30);
                  window.location.href = "https://new.betway.co.za";
                }
              });
      }
    },
    validate(e, input) {
      const field = e ? e.target : input;
      if (field.pattern && new RegExp(field.pattern).test(field.value)) {
        field.parentNode.className = "mb-3 valid";
        field.parentNode.querySelector(".error-text").innerHTML = "";
      } else if (field.required && field.value.trim() === "") {
        field.parentNode.className = "mb-3 required";
        field.parentNode.querySelector(".error-text").innerHTML =
          "This field is required.";
        return false;
      } else {
        field.parentNode.className = " mb-3 invalid";
        field.parentNode.querySelector(".error-text").innerHTML =
          field.getAttribute("errorText");
        return false;
      }
      return true;
    },
  },
  
};

window.addEventListener("scroll", (event) => {
  let y = window.scrollY;
  let el = document.querySelector('.btm-offer');
  if(y > 650){
    el.style.display = 'block';
    el.classList.remove("hidden");
  } else {
    el.style.display = 'none';
  }
});
</script>
<style scoped >
/* modal css */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1060;
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal {
  z-index: 9999;
}

.carousel-bottom-line {
  position: relative;
  height: 7.5px !important;
  background-color: #4c4141;
}

div .m-top {
  position: relative;
  top: -20px;
  height: 5.5px !important;
}

.banner-container{
  height: 93.2vh;
  overflow: hidden;
  position: relative;
}

.container{
  position: absolute;
  z-index: 1;
  height: max-content;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  max-width: 86%;
}

.banner-image, .banner-image div{
  height: 100vh;
}

.banner-image div{
  background-size: cover;
  background-position: 50%;
}

.accordion-button [data-bs-target] {
  position: relative;
  width: 60px;
  height: 6px;
  border: none;
  border-radius: 24px;
}

.accordion-button [data-bs-target] span {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background: #7952b3;
  border-radius: inherit;
}

body {
  font-family: interface, Arial, sans-serif;
  padding-bottom: env(safe-area-inset-bottom);
}

h1,
h2,
h3 {
  font-weight: 700;
}

.login-btn {
  font-weight: 700;
  color: #439539;
  background-color: #fff;
  text-decoration: none;
  font-size: 15px;
  line-height: 1.42857143;
  text-align: center;
  border-radius: 2px;
  border: none;
  padding: 6px 12px;
}

.login-btn:hover {
  color: #fff;
  background-color: #439539;
}

.signup-btn {
  font-weight: 700;
  color: #fff;
  background-color: #439539;
  text-decoration: none;
  font-size: 15px;
  line-height: 1.42857143;
  text-align: center;
  border-radius: 2px;
  border: none;
  padding: 6px 12px;
}

.signup-btn:hover {
  color: #439539;
  background-color: #fff;
}

.carousel {
  height: 93.2vh;
  background-color: #333;
}

.carousel-inner,
.carousel-item {
  height: 92.5vh;
}

.carousel-caption {
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  padding-bottom: 50px;
}

.caption-inner {
  padding: 0 15px;
}

.heading {
  font-size: 16px;
}

.offer {
  font-size: 25px;
  font-weight: 700;
  line-height: 1.2;
}

.desk-offer {
  height: 100%;
  font-weight: 700;
  line-height: 0.7;
}

.pre {
  font-size: 2vw;
  font-weight: 900;
}

.main {
  font-size: 5vw;
  font-weight: 900;
}

.post {
  font-size: 2vw;
}
.esports .desk-offer-content{
  color: #fff;
}

.apps {
  padding: 15px 0;
}

.sponsors {
  padding: 15px 0;
}

.banking {
  padding: 15px 0;
}

.legal {
  border-top: 1px solid #ccc;
  color: #fff;
  background-color: #333;
}

.legal a {
  color: #fff;
}

.foot-logo {
  max-width: 120px;
}

.age-logo {
  filter: invert(1);
  max-width: 35px;
}

.sprite {
  background-image: url(https://cdn2.betway.co.za/images/shared/sprite/spritesheet.png);
  background-repeat: no-repeat;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.sprite-westerncapegovernment {
  width: 150px;
  height: 66px;
  background-position: -625px -408px;
}

.sprite-nationalgamblingboard {
  width: 150px;
  height: 49px;
  background-position: -5px -559px;
}

.cta {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  background-color: #439539;
  border-radius: 2px;
  border: none;
  padding: 10px 35px;
  text-align: center;
  text-decoration: none;
}

.cta:hover {
  color: #fff;
}

.desk-offer .cta {
  font-size: 1.8vw;
  padding: 15px 50px 12px;
  text-transform: uppercase;
  line-height: 1;
}

.form-btn-one {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  background-color: #439539;
  border-radius: 2px;
  border: none;
  padding: 8px 35px 6px;
  text-align: center;
  text-decoration: none;
}

.form-btn-two {
  color: #439539;
  font-size: 18px;
  font-weight: 700;
  background-color: #fff;
  border: 1px solid #439539;
  border-radius: 2px;
  padding: 8px 35px 6px;
  text-align: center;
  text-decoration: none;
}

.btm-offer {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.75);
  padding: 15px;
}

.btm-offer .offer {
  font-size: 22px;
  margin-bottom: 0;
}

.btm-offer .cta {
  padding: 5px;
}

.carousel-indicators {
  top: 0;
  bottom: auto;
  margin-left: 0;
  margin-right: 0;
  overflow: auto;
  white-space: nowrap;
  background-color: rgba(0, 0, 0, 0.75);
}

desktop-btm-line {
  background-color: #2a2727;
  height: 45px;
}

@media (max-width: 1024px) {
  .betway-logo {
    margin-left: unset !important;
  }

  .btm-offer {
    display: none;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.75);
    padding: 15px;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.2);
    }

    100% {
      transform: scale(1.4);
    }
  }
}

@media (max-width: 375px) {
  .btm-offer .offer {
    font-size: 21px;
  }
}

@media (max-width: 320px) {
  .offer {
    font-size: 26px;
  }

  .login-btn,
  .signup-btn {
    font-size: 13px;
    padding: 6px 10px;
  }
}
</style>
